export default {
  // Common labels
  common: {
    welcome: 'Welcome',
    totalPoints: 'Total Points',
    points: 'Points',
    thisMonth: 'this month',
    recentActivity: 'Recent Activity',
    loading: 'Loading...',
    tierProgress: '{points} points to next tier',
    currentUser: 'Current',
    refresh: 'Refresh',
    filter: 'Filter',
    edit: 'Edit',
  },

  // App title and tabs
  app: {
    title: 'GroceryMart Rewards',
    tabs: {
      home: 'Home',
      profile: 'Profile',
      leaderboard: 'Leaderboard',
      rewards: 'Rewards',
    },
  },
  
  // User segments
  segments: {
    advanced: 'Advanced User',
    professional: 'Professional User',
    standard: 'Standard User',
  },
  
  // Membership tiers
  tiers: {
    bronze: 'Bronze',
    silver: 'Silver',
    gold: 'Gold',
    platinum: 'Platinum',
    regular: 'Regular',
  },
  
  // Profile page
  profile: {
    membershipBadge: 'Membership Badge',
    pointsToNextTier: 'points to next tier',
    recentRewards: 'Recent Rewards',
    redeemed: 'Redeemed',
  },
  
  // Home page
  home: {
    pointsEarned: 'Points Earned',
    achievementUnlocked: 'Achievement Unlocked',
    pointsFromPurchase: '+{points} points from your last purchase',
    reachedTop3: 'Reached Top 3 on the leaderboard',
  },
  
  // Leaderboard page
  leaderboard: {
    switchUser: 'Switch User',
    rank: 'Rank',
    pts: 'pts',
    noData: 'No ranking data available',
    anonymous: 'Anonymous',
  },
  
  // Rewards page
  rewards: {
    availableRewards: 'Available',
    allRewards: 'All',
    redeemedRewards: 'Redeemed',
    questProgress: '{progress}/{target} completed',
    notStarted: 'Not started',
    quests: 'Active Quests',
    storeCredit: 'Store Credit',
    foodBeverage: 'Food & Beverage',
    membership: 'Membership',
    other: 'Other',
    redeem: 'Redeem Reward',
    redeeming: 'Redeeming...',
    redeemSuccess: 'Success!',
    redeemFail: 'Failed to redeem reward',
    notEnoughPoints: 'Not Enough Points',
    noRewardsAvailable: 'No rewards available',
    termsAndConditions: 'Terms & Conditions',
    termsDescription: 'Reward must be redeemed within 30 days. Cannot be combined with other offers.',
    progress: 'Progress',
    reward: 'Reward',
    completeQuestToEarn: 'Complete this quest to earn points!',
  },
  
  // User switcher component
  userSwitcher: {
    switchUser: 'Switch User',
  },
  
  // Activity descriptions
  activity: {
    purchasePoints: '+{points} points from your last purchase',
    leaderboardAchievement: 'Reached Top 3 on the leaderboard',
  },
  
  // Date formatting
  dateFormat: {
    dayAgo: '{n} day ago',
    daysAgo: '{n} days ago',
    today: 'Today',
    yesterday: 'Yesterday',
  },
  
  // Language
  language: {
    en: 'English',
    et: 'Estonian',
  },
} 